<table>
    <tr>
        <td [ngStyle]="{'display':'none'}" class="brdr-left-solid"><div class="" id="date-range-filter-up" hidden='true'>
            <mat-form-field
                floatLabel="auto">
                <mat-label>Date range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input readonly (focus)="picker.open()" matInput id="start-date" #start matStartDate
                        placeholder="Start date">
                    <input readonly (focus)="picker.open()" matInput id="end-date" #end matEndDate
                        placeholder="End date">
                </mat-date-range-input>
                <mat-datepicker-toggle id="calendar-click-icon" class="date-toggle-icon-alignment" matSuffix
                    [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>Cancel</button>
                        <button mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
                <mat-icon class="search-icon" matSuffix>close
                </mat-icon>
            </mat-form-field>
        </div></td>
        <td>
            <div class="" id="search-filter-up" class = "pd-l-5">
                <mat-form-field floatLabel="auto" [ngStyle]="{'width':'85px'}">
                    <input id = "upc-search-field" matInput class="body-font-size" (input) = "search($event)" placeholder="Search" #input>
                    <mat-icon matSuffix id="search-icon" class="search-icon-alignment">search</mat-icon>
                </mat-form-field>
            </div>
        </td>
        <td [ngStyle]="{'display':'none'}">
            <div class="d-flex align-items-center">
                <mat-icon class="filter-dropdown-icon-alignment pointer" [matMenuTriggerFor]="menu">expand_more
                </mat-icon>
                <!-- </button> -->
                <mat-menu #menu="matMenu" class="filter-drop-down" style="margin-left: -183px;
                width: 203px;margin-left: -204px;">
                    <button mat-menu-item>
                        <mat-icon>date_range</mat-icon>
                        <span>Next week</span>
                    </button>
                    <button mat-menu-item>
                        <mat-icon>date_range</mat-icon>
                        <span>Next two weeks</span>
                    </button>
                    <button mat-menu-item>
                        <mat-icon>date_range</mat-icon>
                        <span>Date range</span>
                    </button>
                </mat-menu>
            </div>
        </td>
    </tr>
</table>
